module.exports = __webpack_public_path__ + "76c4c05c82148ac471e0f6b94c38b12c.svg";